import { Footer, Navbar } from '../components';
import { About, Explore, Feedback, GetStarted, Hero, Insights, Artefact, World } from '../sections';

const Home = () => {
  return (
    <div className='bg-primary-black overflow-hidden'>
        <Navbar />
        <Hero />
        <div className='relative'>
            <About />
            <div className='gradient-03 z-0'/>
            <Explore />
        </div>
        <div className='relative'>
            <GetStarted />
            <div className='gradient-04 z-0'/>
            <Artefact />
        </div>
        <World />
        <div className='relative'>
            <Insights />
            <div className='gradient-04 z-0'/>
            <Feedback />
        </div>
        <Footer />
    </div>
  )
}

export default Home